"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const mapCamelCaseToSentenceCase = (camelCaseString) => {
    const lowerCaseString = camelCaseString
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .toLowerCase();
    const sentenceCaseString = lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.slice(1);
    return sentenceCaseString;
};
const SubscriptionActivity = ({ feed }) => {
    const reason = feed?.activity?.customField?.['reason'];
    if (reason == null || reason === '') {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Tag, { color: "warning", icon: (0, jsx_runtime_1.jsx)(silhouette_core_1.Tooltip, { title: "Reason is only displayed on TMS", placement: "top", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.InfoOutlinedIcon, {}) }), label: `Reason: ${mapCamelCaseToSentenceCase(reason)}` }));
};
exports.SubscriptionActivity = SubscriptionActivity;
//# sourceMappingURL=SubscriptionActivity.js.map